import React from "react";

/**
 * Photo Bridge logo mark. Amber "b" with shutter — used everywhere.
 * Uses /logo-64.png (crisp at any small size, transparent bg).
 */
export default function Logo({ size = 32, withWordmark = false, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <img
        src="/logo-64.png"
        alt="Photo Bridge"
        width={size}
        height={size}
        style={{ width: size, height: size }}
        className="object-contain shrink-0"
      />
      {withWordmark && <span className="font-display text-xl">Photo Bridge</span>}
    </span>
  );
}
